import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MARKETS } from '../data/content';
import pourImg from '../assets/images/pellets-pour.jpg';
import './Markets.css';

export default function Markets() {
  const { t, lang } = useLanguage();

  return (
    <section id="markets" className="section section--alt markets">
      <div className="container markets__inner">
        <div className="markets__media">
          <img src={pourImg} alt="Plastic raw material pellets" loading="lazy" />
        </div>
        <div className="markets__content">
          <span className="kicker">{t.markets.kicker}</span>
          <h2 className="section-title">{t.markets.title}</h2>
          <p className="markets__intro">{t.markets.intro}</p>
          <ul className="markets__tags">
            {MARKETS.map((m) => (
              <li key={m.en}>{lang === 'ar' ? m.ar : m.en}</li>
            ))}
          </ul>
          <p className="markets__note">{t.markets.note}</p>
        </div>
      </div>
    </section>
  );
}
